<template>
	<div>
		<v-btn
			color="red-lighten-2"
			:disabled="loading"
			@click="showDialog = true"
		>
			<translate>Anonymize</translate>
		</v-btn>
		<v-dialog
			v-model="showDialog"
			width="500"
		>
			<v-card>
				<v-card-text>
					<translate>Are you sure you want to anonymize this note?</translate>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						variant="text"
						:disabled="loading"
						@click="showDialog = false"
					>
						<translate>Cancel</translate>
					</v-btn>
					<v-btn
						variant="text"
						color="red-darken-1"
						:disabled="loading"
						@click="anonymizeNoteSubmit"
					>
						<translate>Anonymize note</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	debounce,
} from 'lodash';
import {
	displayError, inform,
} from 'laravel-front-library';
export default {
	name: 'AnonymizeNoteButton',

	props: {
		noteId: {
			type: Number,
			required: true
		},
		modelName: {
			type: String,
			required: true,
		},
	},

	data () {
		return {
			showDialog: false,
			loading: false
		};
	},

	computed: {
		endpoint () {
			return '/api/v0/' + this.modelName + 'notes/anonymize';
		}
	},

	methods: {
		/**
		 * Submit anonymization of note
		 */
		anonymizeNoteSubmit () {
			this.loading = true;

			axios.post(this.endpoint, {
				'noteId': this.noteId
			}).then(() => {
				inform('Note was successfully anonymized.');
				debounce(() => {
					window.location.reload();
				}, 1000)();
			}).catch((error) => {
				window.captureException(error);
				displayError('Something went wrong while trying to anonymize a note');
			}).finally(() => {
				this.loading = false;
				this.showDialog = false;
			});
		}
	}
};
</script>

